export default "__VITE_ASSET__Bl_CnKZF__"